import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MessageCircle, Heart } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: '#1a1a1a',
        color: '#f7f5ef',
        paddingTop: '4rem',
        paddingBottom: '2rem',
      }}
    >
      <div
        style={{
          maxWidth: '1100px',
          margin: '0 auto',
          padding: '0 2rem',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '3rem',
        }}
      >
        {/* Brand */}
        <div>
          <h2 style={{ margin: '0 0 1.2rem 0', lineHeight: 0, color: '#f7f5ef' }}>
            <Logo variante="studio" style={{ width: 'min(100%, 260px)' }} />
          </h2>
          <p
            style={{
              fontFamily: '"Nunito", sans-serif',
              fontSize: '14px',
              color: '#999',
              lineHeight: 1.75,
              maxWidth: '260px',
            }}
          >
            Narrativas visuais que conectam marcas a pessoas e transformam eventos em memórias inesquecíveis.
          </p>
        </div>

        {/* Navigation */}
        <div>
          <h3
            style={{
              fontFamily: '"Nunito", sans-serif',
              fontSize: '9px',
              letterSpacing: '0.28em',
              color: '#666',
              marginBottom: '1.2rem',
              textTransform: 'uppercase',
              fontWeight: 700,
            }}
          >
            PÁGINAS
          </h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {[
              { path: '/', label: 'Início' },
              { path: '/fashion-film', label: 'Fashion Film' },
              { path: '/rede-social', label: 'Rede Social' },
              { path: '/comercial', label: 'Comercial e Outros' },
            ].map((link) => (
              <li key={link.path} style={{ marginBottom: '0.65rem' }}>
                <Link
                  to={link.path}
                  style={{
                    fontFamily: '"Nunito", sans-serif',
                    fontSize: '14px',
                    color: '#aaa',
                    textDecoration: 'none',
                    transition: 'color 0.2s ease',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#f7f5ef'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = '#aaa'; }}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3
            style={{
              fontFamily: '"Nunito", sans-serif',
              fontSize: '9px',
              letterSpacing: '0.28em',
              color: '#666',
              marginBottom: '1.2rem',
              textTransform: 'uppercase',
              fontWeight: 700,
            }}
          >
            CONTATO
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {[
              { href: 'https://www.instagram.com/morgana.sy/', icon: Instagram, label: '@morgana.sy' },
              { href: 'https://wa.me/5537984162121', icon: MessageCircle, label: '+55 37 98416-2121' },
            ].map(({ href, icon: Icon, label }) => (
              <a
                key={label}
                href={href}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.65rem',
                  color: '#aaa',
                  textDecoration: 'none',
                  fontFamily: '"Nunito", sans-serif',
                  fontSize: '14px',
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#f7f5ef'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = '#aaa'; }}
              >
                <Icon size={14} />
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        style={{
          maxWidth: '1100px',
          margin: '3rem auto 0',
          padding: '1.5rem 2rem 0',
          borderTop: '1px solid #2e2e2e',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '0.5rem',
        }}
      >
        <p style={{ fontFamily: '"Nunito", sans-serif', fontSize: '12px', color: '#555', margin: 0 }}>
          © 2025 Morgana. Todos os direitos reservados.
        </p>
        <p
          style={{
            fontFamily: '"Nunito", sans-serif',
            fontSize: '12px',
            color: '#555',
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '0.3rem',
          }}
        >
          Feito com <Heart size={11} style={{ color: '#c4a882' }} /> para contar histórias
        </p>
      </div>
    </footer>
  );
};

export default Footer;
